import GatewayBase from './gateway-base';
import type { TemplateStatus } from '@monolog/shared/types/database/communications-svc';

export default class CustomizationRestService extends GatewayBase {
  createTemplateOverride(body: {
    content: string;
    storeId: string;
    subject: string;
    templateName: string;
    templatePath: string;
    customizations?: any;
    status?: TemplateStatus;
    senderSignature?: string;
    dkimVerified?: boolean;
    returnPathVerified?: boolean;
  }) {
    return this.client.post('/v1/template-overrides', body);
  }

  getAllStoreTemplateOverrides(storeId: string) {
    return this.client.get(`/v1/template-overrides/${storeId}`);
  }

  deleteTemplateOverride(storeId: string, templateName: string) {
    return this.client.delete(`/v1/template-overrides/${storeId}/${templateName}`);
  }

  updateTemplateOverride(
    storeId: string,
    templateName: string,
    body: {
      content: string;
      subject: string;
      customizations?: any;
      status?: TemplateStatus;
    },
  ) {
    return this.client.put(`/v1/template-overrides/${storeId}/${templateName}`, body);
  }

  getTemplateOverride(storeId: string, templateName: string) {
    return this.client.get(`/v1/template-overrides/${storeId}/${templateName}`);
  }
}
